import { shorten } from './common';

export const CHATGPT_HI_ID = '0a110107';

export const OFFICIAL_ACCOUNT_HI_ID_PREFIX = '0a';

export function getUserNameByUserInfo(user?: UserInfo | null, noComment: boolean = false) {
  const desc = user?.desc;

  return (
    desc?.user.web3_id ||
    (noComment ? '' : desc?.user.memo) ||
    shorten(desc?.id || '', 6, 4).toLowerCase()
  );
}

export function getIsOfficialAccountById(userId: string): boolean {
  return !!userId && userId.length === 8 && userId.startsWith(OFFICIAL_ACCOUNT_HI_ID_PREFIX);
}
export function getIsUserById(userId: string): boolean {
  return !!userId && userId.startsWith(OFFICIAL_ACCOUNT_HI_ID_PREFIX);
}
export function convertOfficialIdToHiId(officialId: string): string {
  return officialId ? `${OFFICIAL_ACCOUNT_HI_ID_PREFIX}${officialId}` : '';
}
export function convertOfficialHiIdToOriginalId(hiId: string = ''): string {
  return hiId?.startsWith('0a') ? hiId.slice(2) : hiId;
}
export function addPrefixToOfficialId(id: string = ''): string {
  return id?.startsWith('0a') ? id : `0a${id}`;
}

export function isContractByUserDesc(data?: UserDesc) {
  return Boolean(
    Object.values(data?.protocol || {}).length + Object.values(data?.contract || {}).length > 0,
  );
}
export function isMultisigContractByUserDesc(data?: UserDesc) {
  return Boolean(Object.values(data?.contract || {}).find(item => item.multisig));
}

export const isOfficalAddress = (address?: string | number) => {
  return !!address && /^[0-9a-z]{6}$/i.test(address?.toString().replace(/^0a/i, ''));
};
